/************************* Preact Files ************************/
import { h, Component } from 'preact';
import { Router } from 'preact-router';
import { connect } from 'preact-redux';

/************************* Custom Component Files ************************/
import Home from './home';
import SDGTargets from './sdg-target-details';
import PaTargets from './pa-target-details';
import OurApproaches from './ourApproaches';
import Profile from './profile';
import Themes from './themes';
import Signature from './signature';
import Project from './project';
import ProjectDetails from './projectDetails';
import SearchResults from './searchResults';
import Donors from './donors';
import About from './aboutUs';
import Sdg from './sdg';
import ProgramArea from './programArea';
import EmbedViewProject from './embedViews/project';
import EmbedProjectDetailsView from './embedViews/projectDetails';
import EmbedDonorsView from './embedViews/donors';
import EmbedRecepientProfileView from './embedViews/profile';
import EmbedHomeRecipientCountry from './embedViews/home/recipientCountry';
import EmbedThemes from './embedViews/themes';
import Preloader from '../components/preLoader';
import EmbedSdgView from './embedViews/sdg';
import EmbedSdgTargetView from './embedViews/sdgTarget';
import ErrorPage from './404Page';
import EmbedHomeTabs from './embedViews/home/homeTabcommon';
import EmbedSignature from './embedViews/signature';
import SdgLanding from './sdgLanding';
import EmbedSdgLandingView from './embedViews/sdgLanding';
import EmbedPaLandingView from './embedViews/paLanding';
import IucnProgrammeArea from './iucnProgrammeArea';
import SSCMarker from './sscMarker';
import EmbedMarkers from './embedViews/markers';
import OAUTH2 from './oauth2';
import DataImport from './dataImport';

/**********************  Third party libraries x**********************/
import Helmet from 'preact-helmet';
import Marker from './marker';
/************************* Redux Action Files ************************/
import { onChangeRoute } from '../shared/actions/routerActions';
import { onAppInit } from '../shared/actions/commonDataActions';
import { fetchMasterSdgList } from '../shared/actions/sdgListActions';
import { fetchSystemInfo } from '../shared/actions/getSystemInfo';
import EmbedSSCMarkerView from './embedViews/sscMarker';
import { ADFS_LINK, HOME_LINK } from '../lib/api';

class Route extends Component {
	handleRoute = (e) => {
		this.currentUrl = e.url;
	}
	componentWillMount() {
		this.props.onAppInit();
		this.props.fetchSystemInfo();
		const token = window.localStorage.token;
		const pathname = window.location.pathname;
		const _ = pathname.split('/').slice(-3);
		if (ADFS_LINK && window.location.host != "open.iucn.org") {
			if (_[0] === 'login' && _[1] === 'token' && _[2]) {
				window.localStorage.setItem('token', _[2]);
				window.location.href = HOME_LINK;
			} else if (!token) {
				window.location.href = ADFS_LINK;
			}
		}
		setInterval(() => this.props.fetchSystemInfo(), 10000);
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.mapCurrentYear != this.props.mapCurrentYear) {
			this.props.fetchMasterSdgList(nextProps.mapCurrentYear);
		}
	}
	render() {
		const title = 'IUCN Open Project Portal',
			description = 'At the request of the MoH, IUCN procures a range of medicines and medical products as an emergency measure, and builds the capacity needed to support a transparent, cost-effective procurement system for the Ministry.';
		return (
			<div id="app">
				<Helmet
					meta={[
						{ property: 'og:type', content: 'website' },
						{ property: 'twitter:image', content: 'https://image.ibb.co/dSzZDH/open_graph_image.png' },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'og:locale', content: 'en_US' },
						{ property: 'og:site_name', content: title },
						{ property: 'og:image', content: 'https://image.ibb.co/dSzZDH/open_graph_image.png' },
						{ property: 'og:secure_url', content: 'https://image.ibb.co/dSzZDH/open_graph_image.png' },
						{ property: 'og:url', content: window.location.href },
						{ name: 'description', content: description },
						{ property: 'og:title', content: title },
						{ property: 'og:description', content: description },
						{ property: 'twitter:title', content: title },
						{ property: 'twitter:description', content: description }
					]}
				/>
				{
					this.props.year.length ?
						<div>
							{
								this.props.systemInfo.status === 1 ?
									<Router onChange={this.handleRoute}>
										<Home path="/" />
										<Project path="/projects" />
										<Profile path="/profile/:code/:type" />
										<SearchResults path="/search-results" />
										<Donors path="/donors" />
										<ProjectDetails path="/projects/:id" />
										<About path="/about-us" />
										<Themes path="/themes/:code/:type" />
										<Signature path="/signature/:code/:type" />
										<Sdg path="/sdg/:code/:type" />
										<Signature path="/programme-area/:code/:type" />
										<SdgLanding path="/sustainable-development-goals" />
										<SDGTargets path="/sdg/targets/:code/:target_id" />
										<PaTargets path="/programme-area/targets/:code/:target_id" />
										<EmbedViewProject path="/embed/projects" />
										<EmbedProjectDetailsView path="/embed/projects/:id" />
										<EmbedThemes path="/embed/themes" />
										<EmbedDonorsView path="/embed/donors" />
										<EmbedRecepientProfileView path="/embed/profile/:code/:type" />
										<EmbedSdgView path="/embed/sdg/" />
										<EmbedHomeRecipientCountry path="/embed/home/recipientCountry" />
										<EmbedHomeTabs path="/embed/home/:type" />
										<EmbedMarkers path="/embed/our-approaches" />
										<EmbedSdgTargetView path="/embed/sdg/targets/" />
										<EmbedSdgTargetView path="/embed/iucn-programme-area/targets/" />
										<EmbedSignature path="/embed/signature" />
										<EmbedSdgLandingView path="/embed/sustainable-development-goals/" />
										<EmbedPaLandingView path="/embed/iucn-programme-area/" />
										<EmbedSSCMarkerView path="/embed/our-approaches/ssc" />
										<IucnProgrammeArea path="/iucn-programme-area" />
										<OurApproaches path="/our-approaches" />
										<Marker path="/our-approaches/:code" />
										<OAUTH2 path="/oauth2/callback" />
										<DataImport path="/updation" />
										<ErrorPage default />
										<SSCMarker path="/our-approaches/ssc/" />
										<ErrorPage default />
									</Router>
									:
									<div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
										<div style={{ width: '600px', textAlign: 'center' }}>
											<img style={{ margin: '0 auto' , display: 'block', width: '80px' }} src="/static/assets/images/logo.png" alt="IUCN Logo" />
											<h1>Service is not available now</h1>
											{
												this.props.systemInfo.status === 3 ? 'System is under maintenance' : 'Data are updating...'
											}
										</div>
									</div>
							}
						</div>
						: <Preloader />
				}
			</div>
		);
	}
}


const mapStateToProps = (state) => {
	const { year } = state.projectTimeline;
	const { countries } = state.countryList;
	const { mapCurrentYear } = state.mapData.yearTimeline;
	const systemInfo = state.systemInfo.data;
	return {
		state,
		year,
		countries,
		router: state.router,
		mapCurrentYear,
		systemInfo
	};
};

const mapDispatchToProps = (dispatch) => ({
	onChangeRoute: (url) => dispatch(onChangeRoute(url)),
	onAppInit: () => dispatch(onAppInit()),
	fetchMasterSdgList: (year) => dispatch(fetchMasterSdgList(year)),
	fetchSystemInfo: () => dispatch(fetchSystemInfo())
});

export default connect(mapStateToProps, mapDispatchToProps)(Route);



// WEBPACK FOOTER //
// ./routes/index.js